export default "__VITE_ASSET__B8fPrWG8__ 400w, __VITE_ASSET__DvRuAZzs__ 800w, __VITE_ASSET__BppRgKaA__ 1024w";